<template>
  <span class="form__error">
    <ErrorIcon class="form__error-icon" width="20px" height="16.5px" />
    {{ msg }}
  </span>
</template>

<script>
import ErrorIcon from "@/assets/svg/icon-form-error.svg";

export default {
  name: "FormError",
  props: {
    msg: {
      type: String,
      default: "Please fix error",
    },
  },
  components: {
    ErrorIcon,
  },
};
</script>
